import { render, staticRenderFns } from "./PrismCode.vue?vue&type=template&id=7b62ddc7&scoped=true&"
import script from "./PrismCode.vue?vue&type=script&lang=js&"
export * from "./PrismCode.vue?vue&type=script&lang=js&"
import style0 from "./PrismCode.vue?vue&type=style&index=0&id=7b62ddc7&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7b62ddc7",
  null
  
)

export default component.exports